import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';
import Moment from 'moment';
import { useHistory } from 'react-router-dom';

import { VscGraph } from 'react-icons/vsc';
import { FaCartPlus, FaEye, FaHubspot, FaMedal, FaPlus } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaUsers } from 'react-icons/fa';
import { FaTrophy } from 'react-icons/fa';
import { FaTicketAlt } from 'react-icons/fa';
import { FaBalanceScaleRight } from 'react-icons/fa';

import api from '~/services/api';

import { onlyNumbers } from '~/helpers/number';

import {
  Scroll,
  Container,
  Header,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
  Progress,
  Loading,
} from '~/components';

import {
  Board,
  Boards,
  Card,
  Cards,
  CountItem,
  LoadArea,
  ProgressTag,
} from './styles';

import MetricaType from '~/@types/metrica';
import PedidoType from '~/@types/pedido';

import { DetailBtn, IdBtn, ShowItensBtn, WhatsappBtn } from '../Pedidos/styles';

import { Align } from '../Produtos/styles';
import { Champion } from '../TopProdutos/styles';
import { Legend, Thumb } from '../VendasPorCanal/styles';

import DetalhesDoPedido from '../Pedidos/DetalhesDoPedido';
import RelatorioVendaTopProdutosProduto from '~/@types/relatoriovendatoprodutosproduto';
import RelatorioVendaTopProdutos from '~/@types/relatoriovendatopprodutos';
import RelatorioVendaCanal from '~/@types/relatoriovendacanal';
import RelatorioVendaCanalMetrica from '~/@types/RelatorioVendaCanalMetrica';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Dashboard: React.FC = () => {
  const history = useHistory();
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);
  const [metricas, setMetricas] = useState<MetricaType[]>([]);
  const [pedidos, setPedidos] = useState<PedidoType[]>([]);
  const [top5Produtos, setTop5Produtos] = useState<
    RelatorioVendaTopProdutosProduto[]
  >([]);
  const [topCanais, setTopCanais] = useState<RelatorioVendaCanalMetrica[]>([]);

  const [detalhesVisiveis, setDetalhesvisiveis] = useState<string[]>([]);

  // DETALHES DO PEDIDO
  const toggleDetalhesPedido = (pIddPedido: string) => {
    if (detalhesVisiveis.includes(pIddPedido)) {
      setDetalhesvisiveis([
        ...detalhesVisiveis.filter(cItem => cItem !== pIddPedido),
      ]);
    } else {
      setDetalhesvisiveis([...detalhesVisiveis, pIddPedido]);
    }
  };

  // DETALHES DO PEDIDO
  const visualizarPedido = (pPedido: PedidoType) => {
    history.push(`pedido/${pPedido.idpedido}`);
  };

  // CONTACTAR VIA WHATSAPP
  const contactarViaWhatsapp = (pPedido: PedidoType) => {
    const urlWhatsapp = `https://api.whatsapp.com/send/?phone=55${onlyNumbers(
      pPedido.cliente.telefone,
    )}
    &text=Olá ${
      pPedido.cliente.nome
    }, Estou entrando em contato referente ao pedido ${
      pPedido.idpedido
    } no valor de ${
      pPedido.precototalformatado
    }&type=phone_number&app_absent=0`;
    window.open(urlWhatsapp, 'blank');
  };

  // PEDIDOS
  const visualizarPedidos = () => {
    history.push(`pedidos`);
  };

  // TOP PRODUTOS
  const visualizarTopProdutos = () => {
    history.push(`top-produtos`);
  };

  // TOP 5 CANAIS
  const visualizarTopCanais = () => {
    history.push(`vendas-por-canal`);
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchUltimos5Pedidos = async () => {
      try {
        setInLoad(true);
        setPedidos([]);

        const response = await api.get(`pedidos?ultimos5pedidos=1`);

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setPedidos(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    const fetchTop5ProdutosHoje = async () => {
      try {
        setInLoad(true);
        setTop5Produtos([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_top_produtos';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          const _data: RelatorioVendaTopProdutos[] = [...data];
          let n;
          for (n in _data) {
            const item = _data[n];
            if (item.nome === 'hoje') {
              setTop5Produtos(item.topprodutos.slice(0, 5));
            }
          }
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    const fetchTopCanais = async () => {
      try {
        setInLoad(true);
        setTopCanais([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_canal';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          const _data: RelatorioVendaCanal[] = [...data];
          let n;
          for (n in _data) {
            const item = _data[n];
            if (item.nome === 'hoje') {
              setTopCanais(item.canais);
            }
          }
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    const fetchMetricas = async () => {
      try {
        setInLoad(true);
        setMetricas([]);

        const response = await api.get(`metricas`);

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setMetricas(data);
        }

        fetchUltimos5Pedidos();
        fetchTop5ProdutosHoje();
        fetchTopCanais();

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchMetricas();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Dashboard"
            subtitle="Veja suas últimas métricas"
            icon={
              <>
                <VscGraph size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          <Cards>
            <main>
              {metricas.map(metrica => (
                <Card>
                  <div>
                    <main>
                      <h2>{metrica.titulo}</h2>
                      <h1>
                        {metrica.emonetario
                          ? metrica.valor.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : metrica.valor}
                      </h1>

                      {metrica.ecomparativo ? (
                        <p>
                          <h3>{metrica.comparativo}</h3>
                          <h4>
                            {metrica.comparativoemonetario
                              ? metrica.comparativovalor.toLocaleString(
                                  'pt-br',
                                  {
                                    style: 'currency',
                                    currency: 'BRL',
                                  },
                                )
                              : metrica.comparativovalor}
                          </h4>
                        </p>
                      ) : null}

                      {metrica.possuibarra ? (
                        <>
                          <span>
                            <ins
                              style={{
                                width: `${metrica.progresso}%`,
                              }}
                              title={`${metrica.progressotitulo}`}
                            />
                          </span>

                          <small>{metrica.progressolegenda}</small>
                        </>
                      ) : null}

                      {metrica.legenda ? (
                        <small>{metrica.legenda}</small>
                      ) : null}
                    </main>
                    <i>
                      {metrica.id === 'faturamento-hoje' ||
                      metrica.id === 'faturamento-este-ms' ||
                      metrica.id === 'total-r-produtos-em-estoque' ? (
                        <span className="money">R$</span>
                      ) : null}

                      {metrica.id === 'clientes-cadastrados-hoje' ? (
                        <FaUsers size={26} color={colors.ORANGE} />
                      ) : null}

                      {metrica.id === 'pedidos-aprovados-neste-ms' ||
                      metrica.id === 'pedidos-aprovados-hoje' ? (
                        <FaCartPlus size={26} color={colors.ORANGE} />
                      ) : null}

                      {metrica.id === 'ticket-mdio-neste-ms' ? (
                        <FaTicketAlt size={26} color={colors.ORANGE} />
                      ) : null}

                      {metrica.id === 'produtos-em-estoque' ? (
                        <FaBalanceScaleRight size={26} color={colors.ORANGE} />
                      ) : null}
                    </i>
                  </div>
                </Card>
              ))}
            </main>
          </Cards>

          <Boards>
            {pedidos.length ? (
              <Board>
                <header>
                  <h1>
                    <i>
                      <FaCartPlus size={26} color={colors.IC1} />
                    </i>
                    <div>
                      <span>Últimos Pedidos</span>
                      <small>HOJE</small>
                    </div>
                  </h1>
                  <button onClick={visualizarPedidos}>
                    <FaPlus size={22} color={colors.IC1} />
                  </button>
                </header>
                <main>
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={40} />
                      <GridHeadItem title="ID" width={100} />
                      <GridHeadItem title="Canal" width={80} />
                      <GridHeadItem title="Data" width={160} />
                      <GridHeadItem title="Cliente" />
                      <GridHeadItem title="Status" width={100} />
                      <GridHeadItem title="Valor" width={120} />
                      <GridHeadItem title="" width={120} />
                    </GridLine>

                    {pedidos.map((pedido, key) => (
                      <>
                        <GridLine key={pedido.idpedido}>
                          <GridItem width={40}>
                            <Align>
                              <CountItem>{key + 1}</CountItem>
                            </Align>
                          </GridItem>
                          <GridItem width={100}>
                            <Align>
                              <IdBtn
                                onClick={() =>
                                  toggleDetalhesPedido(`${pedido.idpedido}`)
                                }
                              >
                                <strong>{pedido.idpedido}</strong>
                              </IdBtn>
                            </Align>
                          </GridItem>

                          <GridItem width={80}>
                            <Legend>
                              <Thumb>
                                <img
                                  src={
                                    pedido.iconecanal
                                      ? pedido.iconecanal
                                      : `https://dummyimage.com/80x80/fff/000&text=${pedido.canal}`
                                  }
                                  title={pedido.canal}
                                  alt={pedido.canal}
                                />
                              </Thumb>
                              <h1>{pedido.canal}</h1>
                            </Legend>
                          </GridItem>

                          <GridItem width={160}>
                            <Align>
                              <strong>{pedido.dt}</strong>
                              <br />
                              <small>
                                {Moment(
                                  pedido.dt,
                                  'DD/MM/YYYY HH:mm',
                                ).fromNow()}
                              </small>
                            </Align>
                          </GridItem>
                          <GridItem>
                            {pedido.cliente ? (
                              <Align>
                                {pedido.cliente.tipo === 'PF' ? (
                                  <>
                                    <strong>
                                      {pedido.cliente.nome}{' '}
                                      {pedido.cliente.sobrenome}
                                    </strong>
                                    <br />
                                    <small>{pedido.cliente.cpf}</small>
                                  </>
                                ) : (
                                  <>
                                    <strong>
                                      {pedido.cliente.razaosocial}
                                    </strong>
                                    <br />
                                    <small>{pedido.cliente.cnpj}</small>
                                  </>
                                )}
                              </Align>
                            ) : (
                              <Align>...</Align>
                            )}
                          </GridItem>
                          <GridItem width={100}>
                            <Align>
                              <span
                                style={{
                                  fontWeight: '700',
                                  padding: 5,
                                  borderRadius: 5,
                                  textTransform: 'uppercase',
                                  background:
                                    pedido.statuscor && pedido.statuscor !== ''
                                      ? pedido.statuscor
                                      : '#999',
                                  fontSize: 12,
                                  color: pedido.status
                                    .toLocaleLowerCase()
                                    .includes('aguardando')
                                    ? '#000'
                                    : '#fff',
                                }}
                              >
                                {pedido.status}
                              </span>
                            </Align>
                          </GridItem>

                          <GridItem width={120}>
                            <Align>
                              <strong>{pedido.precototalformatado}</strong>
                            </Align>
                          </GridItem>

                          <GridItem width={120}>
                            <Align>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                <ShowItensBtn
                                  onClick={() =>
                                    toggleDetalhesPedido(`${pedido.idpedido}`)
                                  }
                                  title="Visualizar Itens do Pedido"
                                >
                                  {detalhesVisiveis.includes(
                                    `${pedido.idpedido}`,
                                  ) ? (
                                    <IoMdArrowDropup
                                      size={26}
                                      color={colors.IC1}
                                    />
                                  ) : (
                                    <IoMdArrowDropdown
                                      size={26}
                                      color={colors.IC1}
                                    />
                                  )}
                                </ShowItensBtn>

                                <DetailBtn
                                  onClick={() => visualizarPedido(pedido)}
                                  title="Visualizar Detalhes do Pedido"
                                >
                                  <FaEye size={22} color={colors.IC1} />
                                </DetailBtn>
                                <WhatsappBtn
                                  onClick={() => contactarViaWhatsapp(pedido)}
                                  title="Entrar em contato Whatsapp"
                                >
                                  <FaWhatsapp size={22} color={colors.GREEN} />
                                </WhatsappBtn>
                              </div>
                            </Align>
                          </GridItem>
                        </GridLine>
                        {detalhesVisiveis.includes(pedido.idpedido) ? (
                          <DetalhesDoPedido pedido={pedido} />
                        ) : null}
                      </>
                    ))}
                  </Grid>
                </main>
              </Board>
            ) : null}

            {top5Produtos.length ? (
              <Board>
                <header>
                  <h1>
                    <i>
                      <FaTrophy size={26} color={colors.IC1} />
                    </i>
                    <div>
                      <span>Top Produtos</span>
                      <small>HOJE</small>
                    </div>
                  </h1>
                  <button onClick={visualizarTopProdutos}>
                    <FaPlus size={22} color={colors.IC1} />
                  </button>
                </header>
                <main>
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={40} />
                      <GridHeadItem title="SKU" width={100} />
                      <GridHeadItem title="Nome" />
                      <GridHeadItem title="Quantidade" width={160} />
                      <GridHeadItem title="Total" width={160} />
                    </GridLine>

                    {top5Produtos.map(topproduto => (
                      <GridLine key={topproduto.idproduto}>
                        <GridItem width={40}>
                          <Align>
                            <CountItem>{topproduto.posicao}</CountItem>
                            {topproduto._posicao <= 3 ? (
                              <Champion>
                                {topproduto._posicao === 1 ? (
                                  <FaTrophy size={18} color={colors.IC1} />
                                ) : (
                                  <FaMedal size={18} color={colors.IC1} />
                                )}
                              </Champion>
                            ) : null}
                          </Align>
                        </GridItem>
                        <GridItem width={100}>
                          <Align>
                            <strong>{topproduto.sku}</strong>
                          </Align>
                        </GridItem>
                        <GridItem>
                          <Align>{topproduto.nome}</Align>
                        </GridItem>
                        <GridItem width={160}>
                          <Align>
                            <div>{topproduto.qtdtotal}</div>
                            <ProgressTag>
                              {topproduto.quantidade_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                        <GridItem width={160}>
                          <Align>
                            <div>
                              {topproduto.total.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </div>
                            <ProgressTag>
                              {topproduto.faturamento_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                </main>
              </Board>
            ) : null}

            {topCanais.length ? (
              <Board>
                <header>
                  <h1>
                    <i>
                      <FaHubspot size={26} color={colors.IC1} />
                    </i>
                    <div>
                      <span>Top Canais</span>
                      <small>HOJE</small>
                    </div>
                  </h1>
                  <button onClick={visualizarTopCanais}>
                    <FaPlus size={22} color={colors.IC1} />
                  </button>
                </header>
                <main>
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={40} />
                      <GridHeadItem title="Canal" width={80} />
                      <GridHeadItem title="Pedidos" />
                      <GridHeadItem title="Total" width={160} />
                      <GridHeadItem title="Ticket Médio" width={160} />
                    </GridLine>

                    {topCanais.map(canal => (
                      <GridLine key={canal.nome}>
                        <GridItem width={40}>
                          <Align>
                            <CountItem>{canal.posicao}</CountItem>
                            {canal._posicao <= 3 ? (
                              <Champion>
                                {canal._posicao === 1 ? (
                                  <FaTrophy size={18} color={colors.IC1} />
                                ) : (
                                  <FaMedal size={18} color={colors.IC1} />
                                )}
                              </Champion>
                            ) : null}
                          </Align>
                        </GridItem>
                        <GridItem width={80}>
                          <Legend>
                            <Thumb>
                              <img
                                src={`https://commerceplus.com.br/includes/bandeiras/${canal.nome}.jpg`}
                                alt={canal.nome}
                                title={canal.nome}
                              />
                            </Thumb>
                            <h1>{canal.nome}</h1>
                          </Legend>
                        </GridItem>
                        <GridItem>
                          <Align>
                            <div>{exibicaoTotalPedidos(canal.pedidos)}</div>
                            <ProgressTag>
                              {canal.pedidos_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                        <GridItem width={160}>
                          <Align>
                            <div>
                              {canal.total.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </div>
                            <ProgressTag>
                              {canal.faturamento_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                        <GridItem width={160}>
                          <Align>
                            {canal.ticketmedio.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Align>
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                </main>
              </Board>
            ) : null}
          </Boards>
        </Container>
      </Scroll>
    </>
  );
};

export default Dashboard;
